import { customFetch } from "../../utils/api";
const apiUrl = process.env.REACT_APP_API_URL;

export const submitLogin = async (email) => {
    const data = { email: email }
    try {
        const response = await customFetch(`${apiUrl}/SignIn`, {
            method: "POST",
            body: JSON.stringify(data)
        }, false);
        if (response.ok) {
            return await response.json();
        }
    } catch (error) {
        console.error("Error fetching token:", error);
    }
}

export const registrateUser = async (dataUser) => {
    const data = { email: dataUser.email };
    try {
        const response = await customFetch(`${apiUrl}/SignUp`, {
            method: "POST",
            body: JSON.stringify(data)
        }, false);
        if (response.ok) {
            return await response.json();
        }
    } catch (error) {
        console.error("Error fetching token:", error);
    }
}

export const checkCode = async (dataUser, loginDetails, code, isAuthorization) => {
    let data = { email: dataUser.email, code: code, codeID: loginDetails.codeID }
    if (isAuthorization) {
        data.isSignUp = false
    } else {
        data.isSignUp = true
        data.name = dataUser.name;
        data.surname = dataUser.surname;
        data.phone = dataUser.phone;
    }
    try {
        const response = await customFetch(`${apiUrl}/checkCode`, {
            method: "POST",
            body: JSON.stringify(data)
        });
        if (response.ok) {
            return await response.json();
        }
    } catch (error) {
        console.error("Error fetching token:", error);
    }
}